import React, { Component } from 'react';
import styles from './letters.css';

import R from '../../assets/svg/R';
import E from '../../assets/svg/E';
import G from '../../assets/svg/G';
import I from '../../assets/svg/I';
import S from '../../assets/svg/S';

class Letters extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mouseX: 0,
      mouseY: 0,
      x: 0,
      y: 0,
      touchEvents: Modernizr.touchevents,
      request: 0,
      orientation: window.orientation
    };

    this.animate = this.animate.bind(this);
    this.lerp = this.lerp.bind(this);
  }

  componentDidMount() {
    this.setState({
      request: requestAnimationFrame(this.animate)
    });
    window.addEventListener('load', this.setEvents);
    this.setEvents();
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.state.request);
    if (this.state.touchEvents) {
      window.removeEventListener('deviceorientation', this.handleOrientation);
      window.removeEventListener('orientationChanged', this.handleOrientationChange);
    } else {
      window.removeEventListener('mousemove', this.handleMouseMove);
    }
    window.removeEventListener('load', this.setEvents);
  }

  setEvents = () => {
    if (this.state.touchEvents) {
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        DeviceMotionEvent.requestPermission()
          .then(response => {
            if (response == 'granted') {
              window.addEventListener('deviceorientation', this.handleOrientation);
              window.addEventListener('orientationchange', this.handleOrientationChange);
            }
          })
          .catch(console.error)
      } else {
        window.addEventListener('deviceorientation', this.handleOrientation);
        window.addEventListener('orientationchange', this.handleOrientationChange);
      }
    } else {
      window.addEventListener('mousemove', this.handleMouseMove);
    }
  }

  setPosition() {
    this.setState({
      x: this.state.x = this.lerp(this.state.x, this.state.mouseX, 0.1),
      y: this.state.y = this.lerp(this.state.y, this.state.mouseY, 0.1)
    });
  }

  lerp(start, end, t) {
    return (1 - t) * start + t * end;
  }

  animate() {
    this.setPosition();
    this.setState({
      request: requestAnimationFrame(this.animate)
    });
  }


  handleOrientationChange = (event) => {
    let orientation = window.orientation;

    this.setState({
      orientation: orientation
    });
  }

  handleOrientation = (event) => {
    const width = window.innerWidth;
    let x = this.state.orientation === 0 ? event.gamma : event.beta;
    let y = this.state.orientation === 0 ? event.beta : event.gamma;
    let factor;

    if (x > 90) { x = 90 };
    if (x < -90) { x = -90 };

    if (width > 600) {
      factor = 20;
    } else {
      factor = 10;
    }

    x = (x / 180) * factor;
    y = (y / 180) * factor;

    this.setState({
      mouseX: x,
      mouseY: y
    });
  }

  handleMouseMove = (event) => {
    if (!this.props.isToggleOn) {
      const width = window.outerWidth;
      const height = window.outerHeight;
      let x = (event.clientX - width / 2) / (width / 9);
      let y = (event.clientY - height / 2) / (width / 9);

      this.setState({
        mouseX: x,
        mouseY: y
      });
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.rContainer}>
          <R className={styles.svg} xValue={this.state.x} yValue={this.state.y} />
        </div>
        <div className={styles.eContainer}>
          <E className={styles.svg} xValue={this.state.x} yValue={this.state.y} />
        </div>
        <div className={styles.gContainer}>
          <G className={styles.svg} xValue={this.state.x} yValue={this.state.y} />
        </div>
        <div className={styles.iContainer}>
          <I className={styles.svg} xValue={this.state.x} yValue={this.state.y} />
        </div>
        <div className={styles.sContainer}>
          <S className={styles.svg} xValue={this.state.x} yValue={this.state.y} />
        </div>
      </div>
    );
  }
}

export default Letters;



// WEBPACK FOOTER //
// ./src/components/Letters/Letters.js